@if ((control?.invalid && (control?.touched || formSubmitted) && errorMessage) || isEnabled) {
	<span class="d-flex gap-2 pt-2">
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.26424 1.33301C4.60557 1.33301 1.62891 4.32367 1.62891 7.99967C1.62891 11.6757 4.61957 14.6663 8.29557 14.6663C11.9716 14.6663 14.9622 11.6757 14.9622 7.99967C14.9622 4.32367 11.9576 1.33301 8.26424 1.33301ZM8.96224 11.333H7.62891V9.99967H8.96224V11.333ZM8.96224 8.66634H7.62891V4.66634H8.96224V8.66634Z"
				fill="#FF7F00" />
		</svg>
		<span class="error-note">{{ errorMessage }}</span>
	</span>
}